var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImportTermsPopupLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 113,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#import_terms_popup_loader_svg__a)",
  d: "M54.558 19.775a9.417 9.417 0 1 1 0-18.834 9.417 9.417 0 1 1 0 18.834m33.293 13.32a8.946 8.946 0 1 1 0-17.892 8.946 8.946 0 0 1 0 17.892m13.791 32.821a8.475 8.475 0 1 1 0-16.95 8.475 8.475 0 0 1 0 16.95M87.851 98.738a8.004 8.004 0 1 1 0-16.008 8.004 8.004 0 0 1 0 16.008m-33.293 13.32a7.533 7.533 0 1 1 0-15.067 7.533 7.533 0 0 1 0 15.067M21.266 97.796a7.063 7.063 0 1 1 0-14.125 7.063 7.063 0 0 1 0 14.125M7.475 64.034a6.592 6.592 0 1 1 0-13.183 6.592 6.592 0 0 1 0 13.183m13.79-33.763a6.12 6.12 0 1 1 0-12.242 6.12 6.12 0 0 1 0 12.242"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "import_terms_popup_loader_svg__a",
  x1: 0.883,
  x2: 124.028,
  y1: 112.058,
  y2: 93.562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4048E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9363F7"
})))));
export default SvgImportTermsPopupLoader;